/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Created_ColInputs */

const en_admin_invite_codes_created_col = /** @type {(inputs: Admin_Invite_Codes_Created_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const zh_admin_invite_codes_created_col = /** @type {(inputs: Admin_Invite_Codes_Created_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Admin_Invite_Codes_Created_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_created_col = /** @type {((inputs?: Admin_Invite_Codes_Created_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Created_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_created_col(inputs)
	return zh_admin_invite_codes_created_col(inputs)
});
export { admin_invite_codes_created_col as "admin.invite_codes.created_col" }